export const DASHBOARD_LABELS = {
  app: {
    name: 'NovaBank',
    logoMark: 'N',
    homeAriaLabel: 'NovaBank Home',
  },
  header: {
    menuToggleAriaLabel: 'Toggle navigation menu',
    darkModeLightAriaLabel: 'Switch to light mode',
    darkModeDarkAriaLabel: 'Switch to dark mode',
    profileMenuAriaLabel: 'Open profile menu',
    notificationsAriaLabel: 'Notifications',
    notificationsEmpty: 'You are all caught up.',
    help: 'Help',
    nav: {
      home: 'Home',
      accounts: 'Accounts',
      payments: 'Payments',
      beneficiaries: 'Beneficiaries',
      statements: 'Statements',
      services: 'Services',
    },
    menu: {
      profile: 'Profile',
      settings: 'Settings',
      darkMode: 'Dark mode',
      logout: 'Logout',
    },
  },
  hero: {
    sectionAriaLabel: 'Greeting',
    subtitle: 'Welcome back to your NovaBank dashboard.',
    guestName: 'Guest',
    greetingMorning: 'Good Morning',
    greetingAfternoon: 'Good Afternoon',
    greetingEvening: 'Good Evening',
  },
  sidebar: {
    navigationAriaLabel: 'Main navigation',
    logoAlt: 'NovaBank',
    lastLoginLabel: 'Last Login:',
    lastLoginDefault: 'N/A',
    logoutLabel: 'Logout',
    logoutAriaLabel: 'Logout',
    profileLoadError: 'Unable to load profile.',
    retry: 'Retry',
    comingSoon: 'Coming Soon',
    closeAriaLabel: 'Close navigation menu',
    nav: {
      home: 'Home',
      pay: 'Pay',
      services: 'Services',
      save: 'Save',
      invest: 'Invest',
      borrow: 'Borrow',
      profile: 'Profile',
    },
  },
  footer: {
    copyright: (year: number, appName: string) => `© ${year} ${appName}. All rights reserved.`,
  },
  balanceCard: {
    availableBalance: 'Available Balance',
    accountNumber: 'Account Number',
    lastUpdated: 'Last Updated',
    hideBalanceAriaLabel: 'Hide balance',
    showBalanceAriaLabel: 'Show balance',
    maskedBalance: '₹ ****.**',
  },
  accountsSection: {
    title: 'Accounts Summary',
    accountEndingAriaLabel: 'account ending in',
    branch: 'Branch',
    ifsc: 'IFSC',
    availableBalance: 'Available Balance',
    lastRefreshed: 'Last Refreshed',
    emptyTitle: 'No Accounts Available',
    emptyMessage: 'You currently have no linked accounts.',
  },
  quickActions: {
    title:'Quick Actions',
    transfer: 'Transfer',
    billPay: 'Bill Pay',
    recharge: 'Recharge',
    addPayee: 'Add Payee',
    deposits: 'Download Deposit Slip',
    loans: 'Loans',
    comingSoon: 'Coming Soon',
  },
  recentTransactions: {
    title: 'Recent Transactions',
    seeAll: 'See All',
    emptyTitle: 'No Transactions',
    emptyMessage: 'You have no recent transactions.',
    listAriaLabel: 'Recent transactions',
  },
  spendingChart: {
    title: 'Monthly Spending',
    totalDebits: 'Total Debits This Month',
    noDataMessage: 'No spending data available.',
    debitCenterLabel: 'Debits',
    categoriesAriaLabel: 'Spending categories',
    chartAriaLabel: 'Monthly spending breakdown',
  },
  profileCard: {
    title: 'Profile',
    titleAriaLabel: 'Profile menu',
    closeAriaLabel: 'Close profile menu',
    customerIdLabel: 'Customer ID:',
    email: 'Email',
    mobile: 'Mobile',
    lastLogin: 'Last Login',
    loading: 'Loading profile...',
  },
  errorState: {
    defaultTitle: 'Something Went Wrong',
    defaultMessage: 'We could not load the requested information. Please try again.',
    retryAriaLabel: 'Retry loading data',
    retry: 'Retry',
  },
  emptyState: {
    defaultTitle: 'No Data Available',
    defaultMessage: 'There is nothing to display at the moment.',
  },
  placeholderPage: {
    message: 'This section is coming soon.',
    backToDashboard: 'Back to Dashboard',
  },
} as const;
